module.exports = __webpack_public_path__ + "img/logo.c2375ba6.png";